import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styles from "./Unsubscribe.module.scss";
import { unsubscribeAction } from "../../../../features/user/userSlice";
import Button from "../../../common/Button/Button";
import { decryptText } from "../../../../Helper/httpRequest";

const Unsubscribe = () => {
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [userId, setUserId] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const urlParams = new URL(window.location.href);
    const encryptedUserId = urlParams.searchParams.get("userId");

    if (encryptedUserId) {
      try {
        const decryptedUserId = decryptText(encryptedUserId);

        if (decryptedUserId) {
          setUserId(decryptedUserId);
        } else {
          console.error("Failed to decrypt userId.");
        }
      } catch (error) {
        console.error("Error during userId decryption:", error);
      }
    } else {
      console.error("No userId found in URL.");
    }
  }, []);

  const handleUnsubscribe = async () => {
    if (!userId) {
      console.error("User ID is missing or invalid.");
      return;
    }

    try {
      const dataObj = { userId };
      const response = await dispatch(unsubscribeAction(dataObj));
      if (response.status === 200) {
        setIsConfirmed(true);
      }
    } catch (error) {
      console.error("Failed to unsubscribe:", error);
    }
  };

  return (
    <div
      className="unsubscribe_box"
      style={{ textAlign: "center", padding: "20px" }}
    >
      {!isConfirmed ? (
        <>
          <h2>Are you sure you want to unsubscribe?</h2>
          <p>
            By unsubscribing, you will no longer receive updates or
            notifications.
          </p>
          <div className={`${styles.submit_btn} mb-0`}>
            <Button fluid type="button" onClick={handleUnsubscribe}>
              Yes, Unsubscribe
            </Button>
          </div>
        </>
      ) : (
        <h3>You have successfully unsubscribed. We're sorry to see you go!</h3>
      )}
    </div>
  );
};

export default Unsubscribe;
